import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { checkIsTicketAlreadyAdded, isNotValidTicket } from '@tickets/helpers/addTicketByType';
import NumericInput from '@common/components/numericInput';
import { useTranslation } from '@common/hooks/translation';
import { getTickets } from '@tickets/helpers/addBarcode';
import { TicketsContext } from '@tickets/store/context';
import ToastWrapper from '@common/helpers/toastWrapper';
import { getTicketType, isOneTimeLoginTicket } from '@tickets/helpers/type';
import { POPUPS } from '@common/constants/popups';
import Config from '@skin_config';
import { store } from '@app/dev/index/terminalApp';
import { AdminUserCommands, CheckOneTimeLogin } from '@app/dev/actions/terminal';
import PaidTicketApi from '@common/services/paidTicketApi';

import './style.scss';
import { handleTicketError } from '@tickets/helpers/error';
import { findByBookId } from '@app/dev/helpers/bookingCheck';

const CheckTicketPopup = ({ openPopup, closePopup }) => {
  const t = useTranslation();
  const [value, setValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [tickets, setTickets] = useContext(TicketsContext);

  const onAdd = async () => {
    if (isLoading) return;

    setValue('');
    setIsLoading(true);

    const ticketType = getTicketType(value);

    if (isOneTimeLoginTicket(value)) {
      store.dispatch(CheckOneTimeLogin(value));
    } else if (value.length >= 5 && value.length <= 7) {
      closePopup();
      findByBookId(value);
    } else if (checkIsTicketAlreadyAdded(tickets, value)) {
      ToastWrapper('error', 'barcode already added');
    } else if (isNotValidTicket(value) || ticketType === null) {
      ToastWrapper('error', 'bet not found');
    } else if (ticketType === 'admin') {
      store.dispatch(
        AdminUserCommands('checkByBarcode', {
          id: value,
        }),
      );
    } else {
      const data = await getTickets(ticketType, value);
      console.log(data, 'sdfosmmfisd');
      if (data?.ticketError?.error) {
        handleTicketError(data);
        ToastWrapper('error', data.ticketError.errorText);
        setIsLoading(false);
      } else {
        setTickets((prevTickets) => ({
          ...prevTickets,
          [ticketType]: [...prevTickets[ticketType],
            { ...data, ticketType, originalBarcode: value }],
        }));
        closePopup();
        openPopup(POPUPS.TICKET_DETAILS_POPUP, { ticketType });
      }
    }

    setIsLoading(false);
  };

  return (
    <div className="T-popup-container T-check-ticket-popup">
      <p className="T-popup-title">{t('Check ticket')}</p>
      <i className="global-icon icon-barcode T-barcode-logo" />
      <p className="T-popup-sub-title">{t('scan your tickets or use "barcode" number')}</p>
      <div className="T-input-wrapper">
        <NumericInput
          setFocus
          className="empty-input"
          onChange={(e) => {
            setValue(e.replace(/[^0-9]/g, ''));
          }}
          value={value}
          placeholder={t('Barcode number')}
          maxLength={Config.barcodeInputMaxLength}
        />
      </div>
      <div className="T-popup-actions">
        <button onClick={closePopup} className="T-action-button" type="button">
          {t('Close')}
        </button>
        <button className="T-action-button submit" onClick={onAdd} type="button">
          {t('Add')}
        </button>
      </div>
    </div>
  );
};

export default CheckTicketPopup;

CheckTicketPopup.propTypes = {
  openPopup: PropTypes.func,
  closePopup: PropTypes.func,
};
